module.exports = __webpack_public_path__ + "img/1.364309d3.png";